import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Ban, AlertTriangle, Calendar, User, AtSign } from 'lucide-react';

const Banned = ({ banInfo }) => {
  // Parsa le info del ban dal messaggio di errore
  // Formato: "BANNED|@NicknameBannatore|Motivo|Scadenza"
  const parts = banInfo?.split('|') || [];
  const bannedBy = parts[1] || '@Staff';
  const motivo = parts[2] || 'Nessun motivo specificato';
  const scadenza = parts[3] || 'Permanente';
  
  const isPermanente = scadenza === 'Permanente';
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-900 via-red-800 to-slate-900 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full bg-white/95 backdrop-blur shadow-2xl border-red-200">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <Ban className="w-12 h-12 text-red-600" />
          </div>
          <CardTitle className="text-3xl font-bold text-red-700">
            Account Sospeso
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-6 h-6 text-red-600 flex-shrink-0 mt-0.5" />
              <div>
                <p className="font-semibold text-red-800 text-lg">
                  Sei stato bannato
                </p>
                <p className="text-red-700 mt-1">
                  Il tuo account è stato sospeso e non puoi accedere al sistema.
                </p>
              </div>
            </div>
          </div>
          
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <AtSign className="w-5 h-5 text-red-500" />
              <div>
                <p className="text-xs text-slate-500 uppercase tracking-wide">Bannato da</p>
                <p className="font-semibold text-red-700">{bannedBy}</p>
              </div>
            </div>
            
            <div className="p-3 bg-slate-50 rounded-lg">
              <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Motivo</p>
              <p className="font-medium text-slate-800">{motivo}</p>
            </div>
            
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <Calendar className="w-5 h-5 text-slate-500" />
              <div>
                <p className="text-xs text-slate-500 uppercase tracking-wide">Durata</p>
                <p className={`font-semibold ${isPermanente ? 'text-red-600' : 'text-amber-600'}`}>
                  {isPermanente ? 'Ban Permanente' : `Fino al ${new Date(scadenza).toLocaleDateString('it-IT', { 
                    day: '2-digit', 
                    month: 'long', 
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}`}
                </p>
              </div>
            </div>
          </div>
          
          <div className="text-center pt-4 border-t">
            <p className="text-sm text-slate-500">
              Se ritieni che questo ban sia stato un errore, contatta lo Staff.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Banned;
